import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import { useEvent, useUnit } from 'effector-react';
import { openModalEvent } from '@nx-frontend/shared/ui/modal';
import { $isOwner } from '@nx-frontend/shared/store/org-role';
import { $wpCanManagePermissions } from '@nx-frontend/shared/store/workspace-access';
import { ManagePopupPayload, PaywallPopupPayload, PaywallPopupReason, PopupType } from '@nx-frontend/shared/types';
import { useOpenPaywallPopupNew } from './use-open-paywall-popup';

export const useOpenManagePopup = () => {
  const [wpCanManagePermissions, isOwner] = useUnit([$wpCanManagePermissions, $isOwner]);
  const [openModal] = useEvent([openModalEvent]);
  const openPaywallPopup = useOpenPaywallPopupNew();

  const t = useTranslations();

  return useCallback(
    (payload: ManagePopupPayload) => {
      if (!wpCanManagePermissions) {
        if (isOwner) {
          const paywallPopupPayload: PaywallPopupPayload = {
            payloadType: PopupType.PAYWALL,
            title: t('features.paywall.title_keep_your_data_under_control'),
            reason: PaywallPopupReason.MANAGE_MEMBERS_GRANULAR,
          };

          openPaywallPopup({ payload: paywallPopupPayload });
        } else {
          openModal({
            title: t('webnotes.webnotes-granular_perm_not_available'),
            content: PopupType.DIALOG,
            closeButtonSize: 18,
            multipopup: false,
            payload: {
              payloadType: PopupType.DIALOG,
              text: t('webnotes.webnotes-granular_perm_not_available_description'),
              buttons: [
                {
                  text: t('webnotes.webnotes-ok'),
                  main: true,
                },
              ],
            },
          });
        }

        return;
      }

      openModal({
        content: PopupType.MANAGE,
        showCloseButton: false,
        payload,
      });
    },
    [isOwner, openModal, openPaywallPopup, wpCanManagePermissions, t]
  );
};
